import { Button } from '@/components/ui/button'
import { ShoppingBagIcon } from 'lucide-react'
import React from 'react'

import { cn } from '@/utilities/cn'

export function OpenCartButton({
  className,
  quantity,
  quiet,
  ...rest
}: {
  className?: string
  quantity?: number
  /** На страницах клуба корзина не кричит, пока пустая — стандарт для сайтов с магазином-разделом. */
  quiet?: boolean
}) {
  const muted = quiet && !quantity
  return (
    <Button
      variant="nav"
      size="clear"
      aria-label={quantity ? `Корзина, ${quantity}` : 'Корзина'}
      className={cn(
        'relative inline-flex items-center gap-2 rounded-full px-4 h-10 font-display text-xs uppercase tracking-wide',
        'transition-colors hover:cursor-pointer',
        muted ? 'text-ink/70 hover:text-punch' : 'bg-ink text-sun hover:bg-punch hover:text-white',
        className,
      )}
      {...rest}
    >
      <ShoppingBagIcon className="h-4 w-4" />
      <span className={cn(muted ? 'sr-only' : 'hidden sm:inline')}>Корзина</span>
      {quantity ? (
        <span className="ml-0.5 inline-flex min-w-5 h-5 items-center justify-center rounded-full bg-sun text-ink text-[11px] font-bold px-1.5">
          {quantity}
        </span>
      ) : null}
    </Button>
  )
}
